module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/stream-browserify/~/isarray/index.js
 ** module id = 814
 ** module chunks = 0
 **/